class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.delay = parseInt(this.dataset.delay) * 1000 || 2000;
    this.reopenDays = parseInt(this.dataset.reopen) || 1;
    this.sectionId = this.dataset.sectionId;

    this.modalOpener = document.querySelector('.newsletter-modal__opener');
    this.closeButton = this.modalOpener?.querySelector('.newsletter-modal__close');
    this.submissionStorageKey = `newsletterPopupSubmission:${this.sectionId}`;
    this.initNewsletterForm();
    this.showPopupAfterDelay();
    this.initCloseButton();

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail.sectionId === this.sectionId) {
          this.show();
        }
      });
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail.sectionId === this.sectionId) {
          this.hide();
        }
      });
    }
  }

  showPopupAfterDelay() {
    const submissionState = this.getSubmissionState();

    if (submissionState) {
      this.show();
      this.restoreScrollPosition(submissionState.scrollY);
      return;
    }

    const modalClosed = localStorage.getItem('newsletterPopupClosed');
    const openerClosed = localStorage.getItem('newsletterOpenerClosed');
    const currentTime = new Date().getTime();

    if (!modalClosed || currentTime > parseInt(modalClosed)) {
      this.popupTimer = setTimeout(() => {
        this.show();
      }, this.delay);
    }
    if (openerClosed && currentTime <= parseInt(openerClosed)) {
      this.hideModalOpener();
    }
  }

  hide() {
    super.hide();
    const expirationDate = new Date().getTime() + this.reopenDays * 24 * 60 * 60 * 1000;
    localStorage.setItem('newsletterPopupClosed', expirationDate);
  }

  onContentHydrated() {
    this.initNewsletterForm();
  }
  initCloseButton() {
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => {
        this.hideModalOpener();
        const openerExpirationDate = new Date().getTime() + this.reopenDays * 24 * 60 * 60 * 1000;
        localStorage.setItem('newsletterOpenerClosed', openerExpirationDate);
      });
    }
  }
  hideModalOpener() {
    if (this.modalOpener) {
      this.modalOpener.style.display = 'none';
    }
  }

  initNewsletterForm() {
    this.newsletterForm = this.querySelector('form.newsletter-form');

    if (!this.newsletterForm || this.newsletterForm.hasAttribute('data-newsletter-form-bound')) return;
    this.newsletterForm.setAttribute('data-newsletter-form-bound', '');

    this.newsletterForm.addEventListener('submit', () => {
      sessionStorage.setItem(
        this.submissionStorageKey,
        JSON.stringify({
          path: window.location.pathname,
          scrollY: window.scrollY,
        })
      );

      const actionUrl = new URL(this.newsletterForm.action);
      actionUrl.hash = '';
      this.newsletterForm.action = actionUrl.toString();
    });
  }

  getSubmissionState() {
    const savedState = sessionStorage.getItem(this.submissionStorageKey);
    if (!savedState) return null;

    sessionStorage.removeItem(this.submissionStorageKey);

    try {
      const submissionState = JSON.parse(savedState);
      return submissionState.path === window.location.pathname ? submissionState : null;
    } catch (error) {
      return null;
    }
  }

  restoreScrollPosition(scrollY) {
    if (!Number.isFinite(scrollY)) return;

    const restore = () => window.scrollTo(window.scrollX, scrollY);
    restore();
    requestAnimationFrame(restore);

    if (document.readyState === 'complete') {
      restore();
    } else {
      window.addEventListener('load', restore, { once: true });
    }
  }
}

customElements.define('newsletter-popup', NewsletterPopup);
